<template>
  <v-container fluid class="grey lighten-2">
    <v-row>
      <v-col class="mt-2" cols="12">
        <v-dialog v-model="dialog" max-width="800" scrollable persistent transition="dialog-bottom-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">
              <v-icon id="smartphone">{{ icon }}</v-icon>{{ phrase.title_smartphone }}
            </v-btn>
          </template>

          <v-card height=400>
            <v-card-title class="text-h5 grey lighten-2">{{ phrase.title_smartphone }}</v-card-title>
            <v-card-text style="white-space: pre-line">
              <div class="my-5 text--primary">{{ help_smartphone_text }}</div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-start">
              <v-btn color="primary" text @click="dialog = false">
                {{ phrase.dialog_close }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <span class="ml-4 font-weight-bold header-total-inline">合計 {{ (this.$store.state.breakdown.smartphone_adult + this.$store.state.breakdown.smartphone_kids).toLocaleString() }}円</span>
      </v-col>
      <v-col>
        <v-row>
          <v-col class="mt-2" cols="12" sm="12" md="4" lg="4">
            <v-card>
              <v-card-title>プラン選択</v-card-title>
              <v-layout justify-center>
                <v-img max-height="200" max-width="200" v-bind:src="require('@/assets/smartphone/smartphone.jpg')"></v-img>
              </v-layout>
              <v-card-text>
                <v-simple-table>
                  <thead></thead>
                  <tbody>
                    <tr v-for="person in people" :key="person.key">
                      <td>{{ person.label }}</td>
                      <td>
                        <v-select
                          :items="planOptions(person)"
                          :value="selectedPlans[person.key]"
                          item-text="select"
                          item-value="id"
                          return-object
                          label="選択してください"
                          @change="value_smartphone_person(person, $event)"
                        ></v-select>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import words from '../assets/words.json'

export default({
  data: () => ({
    icon: 'mdi-cellphone',
    people: [],
    dialog: false,
    phrase: {}
  }),
  mounted: function () {
    this.getWords()
  },
  computed: {
    selectedPlans() {
      return this.$store.state.smartphone_plans || {};
    },
    smartphoneAdult() {
      const list = this.$store.state.login_response.smartphone || [];
      return list
        .filter(p => p.target === '大人')
        .slice()
        .sort((a, b) => a.id - b.id);
    },
    smartphoneAll() {
      const list = this.$store.state.login_response.smartphone || [];
      return list
        .slice()
        .sort((a, b) => a.id - b.id);
    },
    help_smartphone_text () {
      return this.phrase.help_smartphone
    }
  },
  methods: {
    planOptions(person) {
      return person.type === 'child' ? this.smartphoneAll : this.smartphoneAdult;
    },
    value_smartphone_person(person, value) {
      this.$store.commit('set_smartphone_plan', { key: person.key, plan: value });
      this.syncPhoneTotals();
    },
    syncPhoneTotals() {
      const totals = this.people.reduce((acc, p) => {
        const plan = this.selectedPlans[p.key];
        const cost = plan && plan.cost ? plan.cost : 0;
        if (p.type === 'child') {
          acc.kids += cost;
        } else {
          acc.adult += cost;
        }
        return acc;
      }, { adult: 0, kids: 0 });
      this.$store.commit('value_smartphone_adult', { cost: totals.adult, plan: '個別選択' });
      this.$store.commit('value_smartphone_kids', { cost: totals.kids, plan: '個別選択' });
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    getWords: function () {
      this.phrase = words
    }
  },
  created() {
    const lr = this.$store.state.login_response || {};
    const persona = lr.persona || {};
    const people = [];

    people.push({ key: 'self', label: 'あなた', type: 'adult' });

    if (persona.is_married == 1) {
      people.push({ key: 'spouse', label: '配偶者', type: 'adult' });
    }

    const childKeys = ['child1_age', 'child2_age'];
    childKeys.forEach((key, index) => {
      if (Object.prototype.hasOwnProperty.call(persona, key)) {
        const age = Number(persona[key]);
        const label = Number.isFinite(age) ? `子${age}歳` : `子${index + 1}`;
        people.push({ key: `child${index + 1}`, label, type: 'child' });
      }
    });

    this.people = people;
    this.syncPhoneTotals();
  }
})
</script>
